import React, { Component } from "react";

/**
 * @paran (String) direction - up, down, left, right - default is right
 */

class IconArrow extends Component {
    render() {
        const renderDown = () => {
            return (
                <svg x="0px" y="0px" width="16.4px" height="9.2px" viewBox="0 0 16.4 9.2" role="presentation">
                    <path d="M16.1,0.3L8.2,8.4L0.4,0.3" />
                </svg>
            );
        };
        const renderUp = () => {
            return (
                <svg x="0px" y="0px" width="16.4px" height="9.2px" viewBox="0 0 16.4 9.2" role="presentation">
                    <path d="M0.6,8.6l7.9-8.1l7.9,8.1" />
                </svg>
            );
        };
        const renderRight = () => {
            return (
                <svg x="0px" y="0px" width="9.2px" height="16.4px" viewBox="0 0 9.2 16.4" role="presentation">
                    <path d="M0.3,0.4l8.1,7.9l-8.1,7.9" />
                </svg>
            );
        };
        const renderLeft = () => {
            return (
                <svg x="0px" y="0px" width="9.2px" height="16.4px" viewBox="0 0 9.2 16.4" role="presentation">
                    <path d="M8.8,16.1L0.7,8.2l8.1-7.9" />
                </svg>
            );
        };

        const pickArrow = () => {
            const val = this.props.direction || undefined;
            switch (val) {
                case "up":
                    return renderUp();
                case "down":
                    return renderDown();
                case "left":
                    return renderLeft();
                case "right":
                    return renderRight();
                default:
                    return renderRight();
            }
        };
        const arrow = pickArrow();

        return arrow;
    }
}

export default IconArrow;
